import { render, staticRenderFns } from "./HeaderQuickSearch.vue?vue&type=template&id=13355d13"
import script from "./HeaderQuickSearch.vue?vue&type=script&lang=js"
export * from "./HeaderQuickSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports